/*
Sohel 10/26/2022 3031450488 Added Usage and Copy functionality.
Sohel 10/27/2022 3031450488 Integrated FieldList Save API.
Sohel 10/27/2022 3031450488 Integrated get API.
Sohel 10/29/2022 3031450488 reset field list code.
Sohel 10/29/2022 3031450488 fixed reset selected field data issue.
Prakash 10/29/2022 3031450488 Added New UX Changes for Buttons.
Prakash 10/30/2022 3031450488 Added spacing Buttons.
akhila 10/31/2022 3031450488  fixed loading issue
Sohel 10/31/2022 3031450488 selected field list changes
Sohel 10/31/2022 3031450488 Added condition fetch field list
Prakash 10/31/2022 3031450488 Added Accordion styling.
Sohel 10/31/2022 3031450488 Fixed save button not working after new record creation
Sohel 11/01/2022 3031450488 update selected fields data.
madhu 11/17/2022 3031450488 integrated save api
Ashraf 11/18/2022 3031450488 fixed fetching field list data
Ashraf 11/18/2022 3031450488 resetting rules after field list change
Ashraf 11/23/2022 3031450488 changed redux function call for overriding
lalitha 11/23/2022 3031450488 fixed page break issue
Ashraf 11/24/2022 3031450488 fixed fetching formula rule data.
Sohel 11/30/2022 2701012930 field List changes
Saikrishna 12/09/2022 3031450488 save and stay in page functionality added.
Akhila 12/09/2022 3031450488 fixed session saerch issue
Sohel 12/13/2022 3031450488 conditionally hide Save Button
akhila 12/14/2022 3031450488 adding repositoryFields table
akhila 12/14/2022 3031450488 adding update payload
akhila 12/14/2022 3031450488 removed select fields table
kavyareddy 12/15/2022 3031450488 Added role disable condition
Ashraf 12/15/2022 3031450488 fixed role disable condition
akhila 12/16/2022 3031450488 fixed get api issues
Ashraf 15/16/2022 3031450488 fixed role access
Raghu 12/18/2022 3031450488 Added new data fields
akhila 12/18/2022 3031450488 Added unSaved changes popup
akhila 12/19/2022 3031450488 fixed payload issues
dilip 12/19/2022 3031450488 Added rule code and return type
akhila 12/19/2022 3031450488 adding condition for category
akhila 12/23/2022 3031450488 added dbTableName in select fields payload
akhila 12/23/2022 3031450488 added deleteIds in payload
akhila 12/26/2022 3031450488 fixed deleteIds in payload
kavyareddy 12/29/2022 3031450488 Added description
Ashraf 01/02/2022 3031450488 renamed usage header title
Lalitha 01/05/2023 3031450488 fixed download configuration issue
kavyareddy 01/05/2022 3031450488 Fixed uncheck issue in the mapFields
Lalitha 01/10/2023 3031450488 fixed download configuration issue
Akhila 01/18/2023 3031450488 unsaved changes popUp bug fixed
Akhila 01/31/2023 3031450488 Modified Unsaved Changes alert popup
Raghu 02/21/2023 3031450488 changed button color
Prakash  14-04-2023 3031450488 remove marign buttom
Ravi 06/20/2023 3031450488 Added Breadcrums in popup
Akhila 06/21/2023 3031450488 conditionally disable save and finish button on submission
*/
import React, {useState, useEffect, useRef} from 'react';
import {Button, makeStyles, Tooltip} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import {useSelector, useDispatch} from 'react-redux';
import reusableInputStyles from '../../../../../components/InputStyles';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {
  fetchGlobalFieldListData,
} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {
  fetchRuleGroup,
  postBasicInfo,
  setReduxState,
  postFormulaFields,
  postFormulaSelectFields,
  resetFormula,
  resetRuleGroupPrintStatus,
  ResetAddRule as resetAddRule,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import OverrideRule from '../../../../../components/OverrideRule';
import SearchFields from '../../../GlobalFields/DataRepositories/SearchDataRepositories/index';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import DialogBox from './../../../../../components/DialogBox/index';
import FormulaTable from './FormulaTable';
import BreadCrums from '../../../../../util/BreadCrum';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

const useStyles = makeStyles((theme) => ({
  goBackBtn: {
    padding: '6px 12px',
    color: '#320469',
    marginBottom: '10px',
  },
  root: {
    'width': '100%',
    'backgroundColor': '#fff',
    'borderRadius': '4px',
    'border': '1px solid #f3f3f3',
    'marginTop': 10,
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
      backgroundColor: '#fff',
    },
    '& .MuiAccordionSummary-root': {
      backgroundColor: '#f3f3f3',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },
}));

const MapFieldRule = ({
  fieldListCode,
  setFieldListCode,
  handleBack,
  handleNext,
  fieldList,
  setFieldList,
  setSelectedCategory,
  selectedCategory,
  stepSuccessMessage,
  setStepSuccessMessage,
  steps,
  field,
  roleData,
  roleDataAccessDc,
  editExisting,
  handleDirty,
}) => {
  const componentClasses = useStyles();
  const classes = reusableInputStyles();
  const [showSearch, setShowSearch] = useState(false);
  const [overRiding, setOverRiding] = useState({});
  const [dialogState, setDialogState] = useState(false);
  const [open, setOpen] = useState(false);
  const saveRef = useRef();
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const deleteSql = useRef([]);
  const [formulaFields, setFormulaFields] = useState([]);
  const [deletedIds, setDeletedIds] = useState([]);
  const dispatch = useDispatch();
  const {formulaFieldsData, isLoading, successMsg, errorMsg, addFormulaFieldsStatus} =
    useSelector(({addRuleGroup}) => addRuleGroup);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);

  const handleDialogState = () => {
    setDialogState(false);
  };
  const {
    id,
    addRuleData,
    addRuleStatus,
    userMetrix,
    formData,
    basicInfoData,
    downloadSuccessMessage,
  } = useSelector(({addRuleGroup}) => addRuleGroup);

  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);

  const handleSubmit = () => {
    dispatch(submissionStart());
    const data = {
      ...basicInfoData,
      deletedId: deleteSql?.current,
      result: deleteSql?.current?.length > 0 ? '' : basicInfoData?.result,
      isDraft: deleteSql?.current?.length > 0 ? 'Y' : basicInfoData?.isDraft,
    };

    const obj = {};
    formulaFieldsData?.forEach((row) => {
      obj[row?.repositoryName + row?.fieldName] = row?.formulaFieldMapId;
    });
    // {abc123:100}
    formulaFields?.forEach((row2) => {
      if (obj[row2?.repositoryName + row2?.fieldName]) {
        delete obj[row2?.repositoryName + row2?.fieldName];
      }
    });
    const payload =
      formulaFields?.length > 0 &&
      formulaFields?.map((item, i) => {
        const existingId = formulaFieldsData.filter((el) => {
          return el.repositoryName + el.fieldName === item.repositoryName + item.fieldName;
        });
        return {
          category: item?.category ? item.category : '',
          dataType: item?.fieldType ? item.fieldType : '',
          fieldName: item?.fieldName ? item?.fieldName : '',
          formulaFieldMapId: item?.formulaFieldMapId ?
            item?.formulaFieldMapId :
            existingId.length > 0 ?
              existingId[0].formulaFieldMapId :
              0,
          groupCode: basicInfoData?.code ? basicInfoData?.code : '',
          repositoryName: item?.repositoryName ? item?.repositoryName : '',
          ruleType: 'Data Calculations',
          dbTableName: item?.tableColumnName
            ? item?.tableColumnName
            : '',
          filterFormulaGroupId: basicInfoData?.groupId ? basicInfoData?.groupId : 0,
          dataRepositoryId: item?.dataRepositoryId ? item?.dataRepositoryId : 0,
          fieldId: item?.repositoryFieldId
            ? item?.repositoryFieldId
            : 0,
        };
      });

    const passValues = {
      formulaFieldsRequest: payload,
      deleteDataCalculationsFilterIds: Object.values(obj),
    };
    dispatch(setReduxState({property: 'formData', value: data}));
    setOverRiding(data);
    // dispatch(postBasicInfo(data));
    dispatch(postFormulaFields(passValues));
  };

  useEffect(() => {
    if (addFormulaFieldsStatus === 200) {
      setTimeout(() => {
        dispatch(resetFormula());
        !saveRef.current && handleNext();
        if (saveRef.current) {
          dispatch(
            postFormulaSelectFields({
              groupCode: basicInfoData?.code ? basicInfoData?.code : '',
              ruleType: 'Data Calculations',
              filterFormulaRuleGroupId: basicInfoData?.groupId ? basicInfoData?.groupId : 0,
            }),
          );
        }
      }, 2500);
    }
  }, [addFormulaFieldsStatus]);

  useEffect(() => {
    if (addRuleStatus === 200 && userMetrix === 'Yes') {
      setDialogState(true);
      setTimeout(() => {
        dispatch(resetAddRule());
      }, 2500);
    }
  }, [userMetrix, addRuleStatus]);

  useEffect(() => {
    if (downloadSuccessMessage) {
      setTimeout(() => {
        dispatch(resetRuleGroupPrintStatus());
      }, 1500);
    }
  }, [downloadSuccessMessage]);

  useEffect(() => {
    dispatch(
      setReduxState({
        property: 'category',
        value: formData?.category ?
          formData?.category :
          basicInfoData?.category ?
            basicInfoData?.category :
            '',
      }),
    );
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(fetchRuleGroup(id));
    }
  }, [id]);

  useEffect(() => {
    if (formulaFieldsData?.length > 0) {
      const formulaTableData = formulaFieldsData?.map((field) => {
        return {
          category: field?.category,
          formulaFieldMapId: field?.formulaFieldMapId,
          fieldName: field?.fieldName,
          fieldType: field?.dataType,
          repositoryName: field?.repositoryName,
          repositoryType: field?.repositoryType,
          dbTableName: field?.dbTableName,
          dataRepositoryId: field?.dataRepositoryId ? field?.dataRepositoryId : 0,
          repositoryFieldId: field?.fieldId ? field?.fieldId : 0,
        };
      });

      setFormulaFields(formulaTableData);
    }
  }, [formulaFieldsData]);

  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  useEffect(() => {
    if(basicInfoData?.groupId){
      dispatch(
        postFormulaSelectFields({
          groupCode: basicInfoData?.code ? basicInfoData?.code : '',
          ruleType: 'Data Calculations',
          filterFormulaRuleGroupId: basicInfoData?.groupId ? basicInfoData?.groupId : 0,
        }),
      );
    }
  }, [basicInfoData?.groupId]);

  useEffect(() => {
    if (basicInfoData?.fieldListCode) {
      // setFieldListCode(basicInfoData?.fieldListCode);
      // dispatch(fetchFieldListData(basicInfoData?.fieldListCode));
      dispatch(fetchGlobalFieldListData(basicInfoData?.fieldListCode));
    }
  }, [basicInfoData?.fieldListCode]);

  // useEffect(() => {
  //   if (errorMsg || successMsg) {
  //     if (successMsg) {
  //       setStepSuccessMessage(`${steps[1]} added/modified successfully`);
  //     }
  //     setTimeout(() => {
  //       setStepSuccessMessage("");
  //       dispatch(basicInfoResetInfoMessage());
  //     }, 2000);
  //   }
  // }, [errorMsg, successMsg]);

  // useEffect(() => {
  //   if (fieldlListData?.fieldListCode && !showSearch) {
  //     setFieldListCode(fieldlListData?.fieldListCode);
  //     dispatch(fetchFieldListData(fieldlListData?.fieldListCode));
  //   }
  // }, [fieldlListData?.fieldListCode, showSearch]);

  useEffect(() => {
    if (basicInfoData?.fieldListCode && !showSearch) {
      setFieldList(basicInfoData?.fieldListCode);
      setFieldListCode(basicInfoData?.fieldListCode);
    }
  }, [basicInfoData, showSearch]);

  useEffect(() => {
    if (fieldList && !showSearch) {
      dispatch(fetchGlobalFieldListData(fieldList));
    }
  }, [fieldList, showSearch]);

  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  useEffect(() => {
    if (
      deleteSql &&
      fieldList !== basicInfoData.fieldListCode &&
      Object.keys(basicInfoData)?.length > 0 &&
      basicInfoData.isDraft === 'N'
    ) {
      deleteSql.current = [];
      basicInfoData?.addRule?.forEach((el) => deleteSql.current.push(el?.ruleId));
    } else if (
      deleteSql &&
      fieldList === basicInfoData.fieldListCode &&
      Object.keys(basicInfoData)?.length > 0 &&
      basicInfoData.isDraft === 'N'
    ) {
      deleteSql.current = [];
    }
  }, [fieldList]);

  const handleClose = () => {
    setOpen(false);
  };
  // handleDirty(!(formulaFieldsData?.length === formulaFields?.length));
  return (
    <>
      {showSearch && (
        <Button
          variant="text"
          className={` ${componentClasses.goBackBtn}`}
          onClick={() => {
            setShowSearch(false);
          }}
        >
          <ArrowBack className="mr-2" />
          Go Back
        </Button>
      )}
      <div className="d-flex col-12 ">
        <div>
          <BreadCrums
            name={'Data Calculation Name'}
            code={basicInfoData?.code}
            description={'Data Calculation Description'}
            descriptionValue={basicInfoData?.description}
            returnType={'Return Type'}
            returnTypeValue={basicInfoData?.returnType}
          />
        </div>
      </div>
      <div className="new-standard-textfields table-header table-card-header justify-content-end">
        <Button
          variant="outlined"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => setOpen(true)}
          startIcon={<AccountTreeIcon />}
        >
          Map Fields
        </Button>
      </div>
      <FormulaTable
        setFormulaFields={setFormulaFields}
        formulaFields={formulaFields}
        deletedIds={deletedIds}
        setDeletedIds={setDeletedIds}
        handleDirty={handleDirty}
      />
      <DialogBox
        open={open}
        dialogClose={handleClose}
        // title="Search Repository Fields"
        title={
          <div className="dialog-breadcrum">
            <p className="dialoge-title-breadcrum">
              <b>Search Repository Fields</b>
            </p>
            <BreadCrums
              name={'Data Calculation Name'}
              code={basicInfoData?.code}
              description={'Data Calculation Description'}
              descriptionValue={basicInfoData?.description}
            />
          </div>
        }
        maxWidth="xl"
      >
        <SearchFields
          setFormulaFields={setFormulaFields}
          formulaFields={formulaFields}
          setTempSelectedRows={setTempSelectedRows}
          tempSelectedRows={tempSelectedRows}
          //  StepperFieldList={true}
          isReports={true}
          mapFields={true}
          isFormulaTrue={true}
          handleClose={handleClose}
          deletedIds={deletedIds}
          setDeletedIds={setDeletedIds}
          handleDirty={handleDirty}
        />
      </DialogBox>

      <div className="new-standard-textfields d-flex justify-content-center mt-3">
        <Button
          variant="outlined"
          onClick={() => {
            handleBack();
            // setFieldList("");
          }}
          className={`reset-btn mr-1 ${classes.buttonRoot}`}
        >
          Back
        </Button>
        {/* {basicInfoData?.isDraft === "N" && ( */}
        <Button
          variant="outlined"
          type="submit"
          className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
          disabled={
            formulaFields?.length === 0 ||
            (!roleDataAccessDc?.edit && formulaFieldsData?.length > 0 && editExisting) ||
            enabledSubmission
          }
          onClick={() => {
            handleSubmit();
            saveRef.current = true;
            handleDirty && handleDirty(false, 'fixed');
          }}
        >
          Save
        </Button>
        {/* )} */}
        <Tooltip title={formulaFields?.length === 0 ? 'Please Add AtLeast one Field' : ''}>
          <span>
            <Button
              variant="outlined"
              onClick={() => {
                handleSubmit();
                // setFieldList("");
                saveRef.current = false;
              }}
              disabled={
                formulaFields?.length === 0 ||
                (!roleDataAccessDc?.edit && formulaFieldsData?.length > 0 && editExisting) ||
                enabledSubmission
              }
              className={`search-btn ml-1 ${classes.buttonRoot}`}
            >
              Save & Next
            </Button>
          </span>
        </Tooltip>
      </div>
      <OverrideRule
        dialogTitle="Override Business Rule Engine"
        dialogOpen={dialogState}
        dialogClose={handleDialogState}
        title={`This Business Rule Engine has been used in the following places.`}
        data={addRuleData}
        handleOverrideClose={handleDialogState}
        handleOverrideSubmit={() => {
          dispatch(postBasicInfo({...overRiding, override: 'Yes'}));
          handleDialogState();
        }}
      />
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
      )}
      {(successMsg || downloadSuccessMessage || printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={
            successMsg ?
              successMsg :
              printUsageSuccessMsg ?
                printUsageSuccessMsg :
                downloadSuccessMessage
          }
        />
      )}
    </>
  );
};

export default MapFieldRule;
